import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { BasicImage } from '@/components/page-builder/components/BasicImage';
import { cn } from '@/lib/styles';
interface TileIconProps {
  icon: Data.Component<'utilities.basic-image'>;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  iconClassName?: string;
}
const iconSizeClasses = {
  small: 'size-8',
  medium: 'size-12',
  large: 'size-20 md:size-25'
};
export function TileIcon(t0) {
  const $ = _c(10);
  const {
    icon,
    size: t1,
    className,
    iconClassName
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  const t2 = iconSizeClasses[size];
  let t3;
  if ($[0] !== className || $[1] !== iconClassName || $[2] !== t2) {
    t3 = cn("relative shrink-0 flex justify-start items-start self-start", t2, className, iconClassName);
    $[0] = className;
    $[1] = iconClassName;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = !iconClassName;
  let t5;
  if ($[4] !== icon || $[5] !== t4) {
    t5 = <BasicImage component={icon} className="object-contain" fill={t4} />;
    $[4] = icon;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}